import { render, staticRenderFns } from "./ChangesDialog.vue?vue&type=template&id=b72aa3d4&scoped=true&"
import script from "./ChangesDialog.vue?vue&type=script&lang=ts&"
export * from "./ChangesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ChangesDialog.vue?vue&type=style&index=0&id=b72aa3d4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72aa3d4",
  null
  
)

export default component.exports